import { targetingTypes } from '../../../LineItemDv360Create/fields'
import { VIEWABILITY } from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

export const getInitialValues = targeting => {
  const viewability = targeting.find(item => item.type === targetingTypes.TARGETING_TYPE_VIEWABILITY)

  return {
    [VIEWABILITY]: viewability?.viewability || ''
  }
}
